<div class="container mt-5">
    <div class="row">
        <div class="text-center">
        <h2 class="d-flex justify-content-center align-items-center gap-2 mb-4">
            <span class="display-1 fw-bold">4</span>
            <span class="display-1 fw-bold">0</span>
            <span class="display-1 fw-bold bsb-flip-h">4</span>
        </h2>
            <h3 class="h2 mb-2">გვერდი არ არსებობს</h3>
            <a class="btn btn-primary btn-lg" routerLink="/" role="button">მთავარი გვერდი</a>
        </div>
    </div>
</div>